import BuyCourseActionTypes from './buyCourse.types';

export const getProductList = () => ({
	type: BuyCourseActionTypes.FETCH_PRODUCT_LIST.PENDING,
});

export const setCurrentProductId = (id) => ({
	type: BuyCourseActionTypes.SET_CURRENT_PRODUCT_ID,
	payload: id,
});

export const getProductDetails = () => ({
	type: BuyCourseActionTypes.FETCH_PRODUCT_DETAILS.PENDING,
});

export const validateCoupon = (couponCode, price = '') => ({
	type: BuyCourseActionTypes.VALIDATE_COUPON.PENDING,
	payload: { couponCode, price },
});

export const startTransaction = () => ({
	type: BuyCourseActionTypes.START_TRANSACTION.PENDING,
});

export const onCouponChange = (val) => ({
	type: BuyCourseActionTypes.SET_COUPON,
	payload: val,
});

export const updateApiCount = (val) => ({
	type: BuyCourseActionTypes.SET_API_COUNT,
	payload: val,
});

export const logPayment = () => ({
	type: BuyCourseActionTypes.LOG_PAYMENT.PENDING,
});

export const resetChecksum = () => ({
	type: BuyCourseActionTypes.RESET_CHECKSUM,
});

export const setPayMethod = (val) => ({
	type: BuyCourseActionTypes.SET_PAY_METHOD,
	payload: val,
});

export const setShowPreviewCourses = (val) => ({
	type: BuyCourseActionTypes.SHOW_PREVIEW_COURSES,
	payload: val,
});

export const getRelatedCourses = () => ({
	type: BuyCourseActionTypes.FETCH_RELATED_PRODUCTS.PENDING,
});
